import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import SunburstBackground from 'components/elements/SunburstBackground/SunburstBackground'
import classNames from 'lib/util/classNames'
import { useModalContext } from '../../provider/ModalProvider'
import styles from './Media.module.scss'

/**
 * The `Media`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Media (props) {
  const { children, className, size, useBackground } = props
  const { isModalContentActive: isActive } = useModalContext()
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.media,
        styles[`size-${normalizeSizeString(size)}`],
        isActive && styles.active
      ]),
    [isActive, size]
  )

  return (
    <div className={classNameOutput}>
      <div className={styles.bg} />
      <div className={styles.ring}>
        <div className={styles.back} />
        <div className={styles.outer} />
        <div className={styles.inner}>
          <div className={styles.display}>
            {useBackground && <SunburstBackground />}
            <div className={styles.content}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

/** @type {object} */
Media.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  useBackground: PropTypes.bool
}

/** @type {object} */
Media.defaultProps = {
  children: [],
  className: '',
  size: 'standard',
  useBackground: true
}

// Memoize
export default memo(Media)
